import { useState, useEffect, useContext, useRef } from "react";
import Map from "../Map";
import { MyContext } from "../../Context/MyProvider";
import { AnimatePresence, motion } from "framer-motion";
import BtnLoader from "../BtnLoader";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import PriceModel from "../Model/PriceModel";
import LocationInput from "../Model/LocationInput";
import PageLoader from "../PageLoader";
import { useLocation, useNavigate } from "react-router-dom";
import Payment from "../Payment/Payment";
import { useTranslation } from "react-i18next";
import { socket } from "../../socket";

const FindRide = () => {

    const { t } = useTranslation();
    const { BaseUrl, isAuth, handleCallApi, setShowToast, setToastMsg, ranningData } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [step, setStep] = useState(1);
    const [modelType, setModelType] = useState("");
    const [searchText, setSearchText] = useState("");
    const [showModel, setShowModel] = useState("");
    const [apiLoading, setApiLoading] = useState("");
    const [selectedStopIndex, setSelectedStopIndex] = useState(null);
    const [pickupLocation, setPickupLocation] = useState(null);
    const [dropLocation, setDropLocation] = useState(null);
    const [stopList, setStopList] = useState([]);
    const [currentads, setCurrentAds] = useState("");
    const [categoryList, setCategoryList] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [mapLoad, setMapLoad] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [allFindRide, setAllFindRide] = useState([]);
    const [modelData, setModelData] = useState("");
    const [isModel, setIsModel] = useState("");
    const [selectPayment, setSelectPayment] = useState("");
    const [paymentList, setPaymentList] = useState([]);
    const [couponList, setCouponList] = useState([]);
    const [selectCoupon, setSelectCoupon] = useState(null);
    const [allLocation, setAllLoation] = useState([]);
    const [saveMenuIndex, setSaveMenuIndex] = useState(null);
    const [isRouteDetailsOpen, setIsRouteDetailsOpen] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [recentUpdateTrigger, setRecentUpdateTrigger] = useState(0);


    const searchRef = useRef(null);
    const FetchRef = useRef(false);
    const navigate = useNavigate();

    const Location = useLocation();

    const currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        window.scrollTo(0, 0);
        if (Location?.state) {
            const { pick_add, pick_latlon, drop_add, drop_latlon } = Location?.state;
            if (pick_add || pick_latlon) {
                const LocationData = {
                    title: pick_add?.title,
                    subt: pick_add?.subtitle || pick_add?.subt || "",
                    lat: Number(pick_latlon?.latitude),
                    lng: Number(pick_latlon?.longitude),
                }
                setPickupLocation(LocationData);
            }

            if (drop_add || drop_latlon) {
                const LocationData = {
                    title: drop_add?.title,
                    subt: drop_add?.subtitle || drop_add?.subt || "",
                    lat: Number(drop_latlon?.latitude),
                    lng: Number(drop_latlon?.longitude),
                }
                setDropLocation(LocationData);
            }
        }
        const category_list = JSON.parse(secureLocalStorage.getItem("categorylist"));
        setCategoryList(category_list);
        handleGetPaymentList();
    }, []);

    useEffect(() => {
        handleRideRaning(ranningData);
    }, [ranningData]);

    useEffect(() => {
        if (!searchText) {
            setSearchData([]);
            return;
        }
        if (searchText.length < 3) {
            setSearchData([]);
            return;
        }

        const debounce = setTimeout(async () => {
            try {
                setApiLoading("Location");

                const res = await handleCallApi(
                    "Get",
                    `customer/web_map_data?text=${searchText}`
                );

                if (res?.data?.status === 'ERROR') {
                    setShowToast(true);
                    setToastMsg(res.data.message || "Map key error");
                    setSearchData([]);
                } else {
                    const results = res?.data?.results || [];
                    setSearchData(results);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setApiLoading("");
            }
        }, 300);

        return () => clearTimeout(debounce);
    }, [searchText]);

    useEffect(() => {
        if (showModel && searchRef.current) {
            searchRef.current.focus();
        }

        if (showModel) {
            setModelType(showModel);
        }

        document.body.style.overflow = showModel ? "hidden" : "auto";
    }, [showModel]);

    useEffect(() => {
        const locations = [
            { type: "Pickup", ...pickupLocation },
            { type: "Drop", ...dropLocation },
            ...stopList
        ];
        setAllLoation(locations);
    }, [pickupLocation, dropLocation, stopList])

    const handleGetPaymentList = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        const Response = await handleCallApi("Get", "customer/coupon_payment?service=regular");
        if (Response && Response.data) {
            const PaymentList = Response.data.payment_list || [];
            setPaymentList(PaymentList);
            setCouponList(Response.data.coupon_list || []);
            const GetCashData = PaymentList.find((item) => item.name === "Cash");
            if (GetCashData) setSelectPayment(GetCashData);
        }
        setLoading(false);
    }

    const hadnleGetCategoryData = async (mid, lat, lon) => {
        setMapLoad(true);
        const Response = await handleCallApi("Post", "customer/home_mape", { mid, lat, lon });
        setCategoryData(Response.data.list);
        const TimeOut = setTimeout(() => {
            setMapLoad(false);
        }, 500);

        return () => clearTimeout(TimeOut);
    }

    const saveRecentSearch = (location) => {
        try {
            const rawRecents = localStorage.getItem("recent_searches");
            let recents = rawRecents ? JSON.parse(rawRecents) : [];
            recents = recents.filter(item => item.title !== location.title);
            recents.unshift(location);
            recents = recents.slice(0, 5);
            localStorage.setItem("recent_searches", JSON.stringify(recents));
        } catch (e) {
            console.error("Failed to save recent search", e);
        }
    };

    const handleSavePlace = (type, place) => {
        try {
            const uid = secureLocalStorage.getItem("Userid") || "guest";
            const rawPlaces = localStorage.getItem(`saved_places_${uid}`);
            let savedPlaces = rawPlaces ? JSON.parse(rawPlaces) : { home: null, work: null, favorites: [] };

            const location = {
                title: place.name,
                subt: place.formatted_address,
                lat: place.geometry.location.lat,
                lng: place.geometry.location.lng
            };

            if (type === "home") {
                savedPlaces.home = location;
            } else if (type === "work") {
                savedPlaces.work = location;
            } else if (type === "favorite") {
                if (!savedPlaces.favorites) savedPlaces.favorites = [];
                savedPlaces.favorites = savedPlaces.favorites.filter(item => item.title !== location.title);
                savedPlaces.favorites.unshift(location);
                savedPlaces.favorites = savedPlaces.favorites.slice(0, 10);
            }

            localStorage.setItem(`saved_places_${uid}`, JSON.stringify(savedPlaces));
            setShowToast(true);
            setToastMsg(t("Address saved successfully!"));
            setSaveMenuIndex(null);
        } catch (e) {
            console.error("Failed to save place", e);
        }
    };



    const handleRecalculate = async (currentPickup = pickupLocation, currentDrop = dropLocation, currentStops = stopList) => {
        if (!currentPickup || !currentDrop) return;
        
        const hasEmptyStop = currentStops.some(item => !item || !item.lat || !item.lng);
        if (hasEmptyStop) return;

        const allLocations = [
            currentPickup.title.toLowerCase(),
            ...currentStops.map(item => item.title.toLowerCase()),
            currentDrop.title.toLowerCase()
        ];
        const uniqueLocations = new Set(allLocations);
        if (uniqueLocations.size !== allLocations.length) {
            setShowToast(true);
            setToastMsg("Stops must have unique addresses. Duplicate locations are not allowed !!");
            return;
        }

        const uid = secureLocalStorage.getItem("Userid");
        const DropList = currentStops?.map((item) => item && ({ lat: item?.lat, long: item?.lng }));

        const ApiBody = {
            uid,
            mid: categoryList[0]?.id,
            mrole: categoryList[0]?.role,
            pickup_lat_lon: `${currentPickup?.lat},${currentPickup?.lng}`,
            drop_lat_lon: `${currentDrop?.lat},${currentDrop?.lng}`,
            drop_lat_lon_list: DropList || []
        }

        setApiLoading("Recalc");
        setModelData("");
        setCategoryData([]);

        try {
            const Response = await handleCallApi("Post", "customer/calculate", ApiBody);
            const Response2 = await handleCallApi("Post", "customer/module_calculate", ApiBody);
            
            if (Response && Response.data && Response2 && Response2.data) {
                const OtherData = {
                    ...Response.data.vehicle,
                    ...Response.data,
                    bid_addjust_amount: Response.data.drop_price,
                }
                const AllRide = [OtherData, ...Response2.data.caldriver];
                setAllFindRide(AllRide);
                if (AllRide.length > 0 && currentPickup) {
                    setModelData(AllRide[0]);
                    hadnleGetCategoryData(AllRide[0].id, currentPickup.lat, currentPickup.lng);
                }
            }
        } catch (e) {
            console.error("Recalculation failed", e);
        } finally {
            setApiLoading("");
        }
    }

    const handleSelectLocation = (data) => {
        const LocationData = {
            title: data.name,
            subt: data?.formatted_address || "",
            lat: data.geometry.location.lat,
            lng: data.geometry.location.lng,
        }

        saveRecentSearch(LocationData);

        if (modelType === "Pickup") {
            setPickupLocation(LocationData);
            if (step === 3) {
                handleRecalculate(LocationData, dropLocation, stopList);
            }
        } else if (modelType === "Drop") {
            setDropLocation(LocationData);
            if (step === 3) {
                handleRecalculate(pickupLocation, LocationData, stopList);
            }
        } else if (modelType === "Stop") {
            const updatedStops = [...stopList];
            updatedStops[selectedStopIndex] = LocationData;
            setStopList(updatedStops);
            if (step === 3) {
                handleRecalculate(pickupLocation, dropLocation, updatedStops);
            }
        }

        closeModal();
    }

    const handleGetCurrentLocation = () => {
        if (!navigator.geolocation) {
            setShowToast(true);
            setToastMsg(t("Geolocation is not supported by your browser"));
            return;
        }

        setApiLoading("Location");
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                try {
                    const response = await handleCallApi(
                        "Get",
                        `customer/reverse_geocode?lat=${lat}&lng=${lng}`
                    );

                    if (response.data && response.data.results && response.data.results.length > 0) {
                        const result = response.data.results[0];
                        const placeData = {
                            name: result.formatted_address.split(",")[0] || "Current Location",
                            formatted_address: result.formatted_address,
                            geometry: {
                                location: {
                                    lat: lat,
                                    lng: lng
                                }
                            }
                        };
                        handleSelectLocation(placeData);
                    } else {
                        setShowToast(true);
                        setToastMsg(t("Could not fetch address for your location."));
                    }
                } catch (err) {
                    console.error("Error geocoding location:", err);
                    setShowToast(true);
                    setToastMsg(t("Error getting location address."));
                } finally {
                    setApiLoading("");
                }
            },
            (error) => {
                console.error("Geolocation error:", error);
                setShowToast(true);
                setToastMsg(t("Location permission denied or unavailable."));
                setApiLoading("");
            }
        );
    };

    const closeModal = () => {
        setSearchText("");
        setSearchData([]);
        setShowModel("");
    };

    const addStop = () => {
        if (stopList.length >= 1 && !stopList[stopList.length - 1]) {
            setShowToast(true);
            setToastMsg("Please enter data in the previous field first !!");
            return;
        }
        setStopList((prev) => [...prev, null]);
    };

    const removeStop = (index) => {
        const updated = stopList.filter((_, i) => i !== index);
        setStopList(updated);
        if (step === 3) {
            handleRecalculate(pickupLocation, dropLocation, updated);
        }
    };

    const moveStopUp = (index) => {
        if (index === 0) return;
        const newList = [...stopList];
        const temp = newList[index];
        newList[index] = newList[index - 1];
        newList[index - 1] = temp;
        setStopList(newList);
        if (step === 3) {
            handleRecalculate(pickupLocation, dropLocation, newList);
        }
    };

    const moveStopDown = (index) => {
        if (index === stopList.length - 1) return;
        const newList = [...stopList];
        const temp = newList[index];
        newList[index] = newList[index + 1];
        newList[index + 1] = temp;
        setStopList(newList);
        if (step === 3) {
            handleRecalculate(pickupLocation, dropLocation, newList);
        }
    };

    const HandleGetGoogleAddress = async (lat, lng) => {
        try {
            const response = await handleCallApi(
                "Get",
                `customer/reverse_geocode?lat=${lat}&lng=${lng}`
            );
            if (response.data && response.data.results && response.data.results.length > 0) {
                const fulladdress = {
                    name: response.data.results[0]?.formatted_address,
                    formatted_address: "",
                    ...response.data.results[0]
                };
                setCurrentAds(fulladdress);
            } else {
                setShowToast(true);
                setToastMsg(t("Could not fetch address for your location."));
            }
        } catch (error) {
            console.error("Error fetching address:", error);
            setShowToast(true);
            setToastMsg(t("Error getting location address."));
            return "";
        }
    };

    const hadnleFindRide = async () => {

        if (!pickupLocation) {
            setShowToast(true);
            setToastMsg("Please select pickup location !!");
            return;
        }

        if (!dropLocation) {
            setShowToast(true);
            setToastMsg("Please select dropoff location !!");
            return;
        }

        const hasEmptyStop = stopList.some(item => !item || !item.lat || !item.lng);
        if (hasEmptyStop) {
            setShowToast(true);
            setToastMsg("Please fill all stop locations !!");
            return;
        }

        // Validate duplicates
        const allLocations = [
            pickupLocation.title.toLowerCase(),
            ...stopList.map(item => item.title.toLowerCase()),
            dropLocation.title.toLowerCase()
        ];
        const uniqueLocations = new Set(allLocations);
        if (uniqueLocations.size !== allLocations.length) {
            setShowToast(true);
            setToastMsg("Stops must have unique addresses. Duplicate locations are not allowed !!");
            return;
        }

        const allCoords = [
            `${Number(pickupLocation.lat).toFixed(5)},${Number(pickupLocation.lng).toFixed(5)}`,
            ...stopList.map(item => `${Number(item.lat).toFixed(5)},${Number(item.lng).toFixed(5)}`),
            `${Number(dropLocation.lat).toFixed(5)},${Number(dropLocation.lng).toFixed(5)}`
        ];
        const uniqueCoords = new Set(allCoords);
        if (uniqueCoords.size !== allCoords.length) {
            setShowToast(true);
            setToastMsg("Stops must have unique addresses. Duplicate locations are not allowed !!");
            return;
        }

        if (!isAuth) {
            setShowModel("Login");
            return;
        }

        const uid = secureLocalStorage.getItem("Userid");
        const DropList = stopList?.map((item) => item && ({ lat: item?.lat, long: item?.lng }));

        const ApiBody = {
            uid,
            mid: categoryList[0]?.id,
            mrole: categoryList[0]?.role,
            pickup_lat_lon: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop_lat_lon: `${dropLocation?.lat},${dropLocation?.lng}`,
            drop_lat_lon_list: DropList || []
        }

        setApiLoading("Search");

        const Response = await handleCallApi("Post", "customer/calculate", ApiBody);
        const Response2 = await handleCallApi("Post", "customer/module_calculate", ApiBody);
        const OtherData = {
            ...Response.data.vehicle,
            ...Response.data,
            bid_addjust_amount: Response.data.drop_price,
        }
        const AllRide = [OtherData, ...Response2.data.caldriver];
        setAllFindRide(AllRide);
        setApiLoading("");
        if (AllRide.length > 0 && pickupLocation) {
            setModelData(AllRide[0]);
            hadnleGetCategoryData(AllRide[0].id, pickupLocation.lat, pickupLocation.lng);
        }
        setStep(3);
    }

    const handleContinueBooking = () => {
        if (!modelData) {
            setShowToast(true);
            setToastMsg("Please select service !!");
            return;
        }
        setShowModel("Price");
    }

    const handleCancelRequest = async () => {
        setApiLoading("Cancel");
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await handleCallApi("Post", "customer/remove_vehicle_request", { uid });
        setShowToast(true);
        setToastMsg(Response?.data?.message);
        if (Response.data.ResponseCode) {
            setShowModel("");
            socket.emit("AcceRemoveOther", { requestid: Response.data?.id, driverid: Response.data?.driver_list });
        }
        setApiLoading("");
    }

    const handleRequestTimeOut = async (requestId) => {
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await handleCallApi("Post", "customer/timeout_vehicle_request", { request_id: requestId, uid });
        if (Response?.data?.Result) {
            socket.emit("RequestTimeOut", {
                requestid: Response.data?.id,
                driverid: Response.data?.driverid
            });
        }
    }

    const handleRideRaning = (data) => {
        if (!data) {
            setShowModel("");
            setStep(1);
            setPickupLocation(null);
            setDropLocation(null);
            setStopList([]);
            setModelData(null);
            return;
        }
        const { pick_add, pick_latlon, drop_add, drop_latlon, drop_add_list, drop_latlon_list, increased_time, bidding_status, price } = data;

        if ((data && price && bidding_status) || data.status == '0') {
            const ModelData = {
                ...data,
                tot_price: price || data.tot_price,
                bid_addjust_amount: price || data.tot_price,
                bidding: bidding_status || data.bidding,
            }
            setModelData(ModelData);
        }


        if (increased_time || data.status == '0') {
            setShowModel("Price");
        }

        if (pick_add || pick_latlon) {
            const LocationData = {
                title: pick_add?.title,
                subt: pick_add?.subtitle || pick_add?.subt || "",
                lat: Number(pick_latlon?.latitude),
                lng: Number(pick_latlon?.longitude),
            }
            setPickupLocation(LocationData);
        }

        if (drop_add || drop_latlon) {
            const LocationData = {
                title: drop_add?.title,
                subt: drop_add?.subtitle || drop_add?.subt || "",
                lat: Number(drop_latlon?.latitude),
                lng: Number(drop_latlon?.longitude),
            }
            setDropLocation(LocationData);
        }

        if (drop_add_list || drop_latlon_list) {
            const dropList = drop_add_list.map((item, index) => ({
                title: item?.title,
                subt: item?.subtitle || item?.subt || "",
                lat: Number(drop_latlon_list[index]?.latitude),
                lng: Number(drop_latlon_list[index]?.longitude),
            }));
            setStopList(dropList);
        }

    }

    return (
        <div className="find-ride-page">

            <div className="find-container px-3">
                <div className="h-full lg:h-[calc(100vh-100px)] flex flex-col-reverse lg:flex-row items-start gap-6">

                    <div className="w-full lg:max-w-[400px] lg:min-w-[400px] h-[fit-content] max-h-full bg-white p-[15px] border rounded-[15px] relative flex flex-col scroll-container">

                        {step === 1 && (
                            <>
                                <div className="flex justify-between items-center">
                                    <h1 className="font-bold text-[20px]">
                                        {t("Get a ride")}
                                    </h1>

                                    <button
                                        onClick={addStop}
                                        className="border px-3 py-1 rounded-full text-sm"
                                    >
                                        {t("+ Add stop")}
                                    </button>
                                </div>

                                <div className="my-4 space-y-3 max-h-full scroll-container">

                                    <LocationInput
                                        value={pickupLocation?.subt || pickupLocation?.title}
                                        placeholder="Pickup location"
                                        color="location-icon-green"
                                        onClick={() => setShowModel("Pickup")}
                                        onClear={() => setPickupLocation(null)}
                                    />

                                     {stopList.map((stop, index) => (
                                         <div key={index} className="flex gap-2 items-center">
                                             <div className="flex-1">
                                                 <LocationInput
                                                     value={stop?.subt || stop?.title}
                                                     placeholder="Stop location"
                                                     color="location-icon-yellow"
                                                     onClick={() => { setSelectedStopIndex(index); setShowModel("Stop"); }}
                                                     onClear={() => removeStop(index)}
                                                 />
                                             </div>
                                             <div className="flex flex-col justify-center gap-0.5">
                                                 <button
                                                     onClick={() => moveStopUp(index)}
                                                     disabled={index === 0}
                                                     className={`p-1 rounded hover:bg-gray-150 ${index === 0 ? "opacity-30 cursor-not-allowed" : ""}`}
                                                     type="button"
                                                     title="Move Up"
                                                 >
                                                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                         <path d="M12 4L4 12H9V20H15V12H20L12 4Z" fill="currentColor" className="text-gray-500" />
                                                     </svg>
                                                 </button>
                                                 <button
                                                     onClick={() => moveStopDown(index)}
                                                     disabled={index === stopList.length - 1}
                                                     className={`p-1 rounded hover:bg-gray-150 ${index === stopList.length - 1 ? "opacity-30 cursor-not-allowed" : ""}`}
                                                     type="button"
                                                     title="Move Down"
                                                 >
                                                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                         <path d="M12 20L20 12H15V4H9V12H4L12 20Z" fill="currentColor" className="text-gray-500" />
                                                     </svg>
                                                 </button>
                                             </div>
                                             <button onClick={() => removeStop(index)} className="flex items-center justify-center p-1 rounded hover:bg-gray-150">
                                                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                     <path className="text-gray-200" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor" />
                                                     <path d="M13.061 12L15.531 9.53005C15.824 9.23705 15.824 8.76202 15.531 8.46902C15.238 8.17602 14.763 8.17602 14.47 8.46902L12 10.939L9.52999 8.46902C9.23699 8.17602 8.76199 8.17602 8.46899 8.46902C8.17599 8.76202 8.17599 9.23705 8.46899 9.53005L10.939 12L8.46899 14.47C8.17599 14.763 8.17599 15.238 8.46899 15.531C8.61499 15.677 8.80699 15.751 8.99899 15.751C9.19099 15.751 9.38298 15.678 9.52898 15.531L11.999 13.061L14.469 15.531C14.615 15.677 14.807 15.751 14.999 15.751C15.191 15.751 15.383 15.678 15.529 15.531C15.822 15.238 15.822 14.763 15.529 14.47L13.061 12Z" fill="currentColor" />
                                                 </svg>
                                             </button>
                                         </div>
                                     ))}

                                    <LocationInput
                                        value={dropLocation?.subt || dropLocation?.title}
                                        placeholder="Dropoff location"
                                        color="location-icon-red"
                                        onClick={() => setShowModel("Drop")}
                                        onClear={() => setDropLocation(null)}
                                    />
                                </div>

                                <button onClick={hadnleFindRide} className="min-h-12 w-full mt-3 rounded-[8px] bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95">
                                    {apiLoading === "Search"
                                        ? <BtnLoader CustomeStyle={"bg-white"} />
                                        : t("Search")}
                                </button>

                            </>
                        )}

                        {step === 2 && (
                            <>
                                <h1 className="font-bold text-[20px]">
                                    {t("Choose your pickup spot")}
                                </h1>

                                <p className="text-[17px] my-2">{currentads?.name}</p>

                                <button onClick={() => { setStep(1); handleSelectLocation(currentads); }} className="h-12 w-full rounded-[8px] mt-2 bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95">
                                    {t("Confirm pickup")}
                                </button>

                                <button
                                    onClick={() => setStep(1)}
                                    className="h-12 w-full rounded-[8px] border border-[--bg-color] mt-3 italic text-[--bg-color] tracking-[1px] font-bold transition-transform active:scale-95"
                                >
                                    {t("Cancel")}
                                </button>
                            </>
                        )}

                        {step === 3 && (<>

                            <div className="flex items-center gap-3">
                                <button onClick={() => { setStep(1); setModelData(""); setCategoryData([]); }} className='hover:bg-gray-100 rounded-full p-2'>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22.0001 12C22.0001 12.552 21.5531 13 21.0001 13H5.41413L10.7071 18.293C11.0981 18.684 11.0981 19.3161 10.7071 19.7071C10.5121 19.9021 10.2561 20 10.0001 20C9.74407 20 9.48804 19.9021 9.29304 19.7071L2.29401 12.708C2.20101 12.615 2.12797 12.5051 2.07697 12.3821C1.97597 12.1381 1.97597 11.862 2.07697 11.618C2.12797 11.495 2.20101 11.385 2.29401 11.292L9.29304 4.29301C9.68403 3.90201 10.3161 3.90201 10.7071 4.29301C11.0981 4.68401 11.0981 5.31607 10.7071 5.70707L5.41413 11H21.0001C21.5531 11 22.0001 11.448 22.0001 12Z" fill="black" />
                                    </svg>
                                </button>
                                <h1 className="font-bold text-[20px]">{t("Select service")}</h1>
                            </div>

                            <div className="border border-gray-200 rounded-[10px] p-3 mt-3 bg-gray-50/50">
                                <div 
                                    className="flex justify-between items-center cursor-pointer select-none"
                                    onClick={() => setIsRouteDetailsOpen(!isRouteDetailsOpen)}
                                >
                                    <div className="flex items-center gap-2">
                                        <svg 
                                            width="16" 
                                            height="16" 
                                            viewBox="0 0 24 24" 
                                            fill="none" 
                                            stroke="currentColor" 
                                            strokeWidth="2.5" 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round" 
                                            className={`text-gray-600 transition-transform duration-200 ${isRouteDetailsOpen ? 'rotate-90' : ''}`}
                                        >
                                            <polyline points="9 18 15 12 9 6" />
                                        </svg>
                                        <span className="font-semibold text-sm text-gray-700">{t("Route Details")}</span>
                                    </div>
                                    <span className="text-xs text-gray-500 font-medium bg-gray-200 px-2 py-0.5 rounded-full">
                                        {stopList.length > 0 ? `${stopList.length} stop${stopList.length > 1 ? 's' : ''}` : t("Direct ride")}
                                    </span>
                                </div>

                                {isRouteDetailsOpen && (
                                    <div className="mt-3 pt-3 border-t border-gray-200 space-y-3">
                                        <LocationInput
                                            value={pickupLocation?.subt || pickupLocation?.title}
                                            placeholder="Pickup location"
                                            color="location-icon-green"
                                            onClick={() => setShowModel("Pickup")}
                                            onClear={() => setPickupLocation(null)}
                                        />

                                        {stopList.map((stop, index) => (
                                            <div key={index} className="flex gap-2 items-center">
                                                <div className="flex-1">
                                                    <LocationInput
                                                        value={stop?.subt || stop?.title}
                                                        placeholder="Stop location"
                                                        color="location-icon-yellow"
                                                        onClick={() => { setSelectedStopIndex(index); setShowModel("Stop"); }}
                                                        onClear={() => removeStop(index)}
                                                    />
                                                </div>
                                                <div className="flex flex-col justify-center gap-0.5">
                                                    <button
                                                        onClick={() => moveStopUp(index)}
                                                        disabled={index === 0}
                                                        className={`p-1 rounded hover:bg-gray-150 ${index === 0 ? "opacity-30 cursor-not-allowed" : ""}`}
                                                        type="button"
                                                        title="Move Up"
                                                    >
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12 4L4 12H9V20H15V12H20L12 4Z" fill="currentColor" className="text-gray-500" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => moveStopDown(index)}
                                                        disabled={index === stopList.length - 1}
                                                        className={`p-1 rounded hover:bg-gray-150 ${index === stopList.length - 1 ? "opacity-30 cursor-not-allowed" : ""}`}
                                                        type="button"
                                                        title="Move Down"
                                                    >
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12 20L20 12H15V4H9V12H4L12 20Z" fill="currentColor" className="text-gray-500" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <button onClick={() => removeStop(index)} className="flex items-center justify-center p-1 rounded hover:bg-gray-150">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path className="text-gray-200" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor" />
                                                        <path d="M13.061 12L15.531 9.53005C15.824 9.23705 15.824 8.76202 15.531 8.46902C15.238 8.17602 14.763 8.17602 14.47 8.46902L12 10.939L9.52999 8.46902C9.23699 8.17602 8.76199 8.17602 8.46899 8.46902C8.17599 8.76202 8.17599 9.23705 8.46899 9.53005L10.939 12L8.46899 14.47C8.17599 14.763 8.17599 15.238 8.46899 15.531C8.61499 15.677 8.80699 15.751 8.99899 15.751C9.19099 15.751 9.38298 15.678 9.52898 15.531L11.999 13.061L14.469 15.531C14.615 15.677 14.807 15.751 14.999 15.751C15.191 15.751 15.383 15.678 15.529 15.531C15.822 15.238 15.822 14.763 15.529 14.47L13.061 12Z" fill="currentColor" />
                                                    </svg>
                                                </button>
                                            </div>
                                        ))}

                                        <LocationInput
                                            value={dropLocation?.subt || dropLocation?.title}
                                            placeholder="Dropoff location"
                                            color="location-icon-red"
                                            onClick={() => setShowModel("Drop")}
                                            onClear={() => setDropLocation(null)}
                                        />

                                        <div className="flex justify-end pt-1">
                                            <button
                                                onClick={addStop}
                                                className="border px-3 py-1 rounded-full text-xs font-semibold hover:bg-gray-100 transition-colors"
                                            >
                                                {t("+ Add stop")}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="mt-3 space-y-3 max-h-full scroll-container relative min-h-[150px]">
                                {apiLoading === "Recalc" && (
                                    <div className="absolute inset-0 bg-white/70 z-10 flex items-center justify-center rounded-[10px]">
                                        <BtnLoader CustomeStyle="bg-[--bg-color]" />
                                    </div>
                                )}
                                {allFindRide.map((item, index) => {
                                    const IsSelect = item.id === modelData?.id
                                    return <div key={index} onClick={() => { hadnleGetCategoryData(item.id, pickupLocation.lat, pickupLocation.lng); setModelData(item); }} className={`border ${IsSelect ? "border-[--bg-color]" : "border-gray-300"} p-[10px] rounded-[10px] cursor-pointer flex items-center justify-between gap-2`}>
                                        <div className="flex items-center gap-2">
                                            <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-[50px] h-[50px]"} ImagStyle={"w-full h-full object-cover"} alt={item.name} status={false} />
                                            <div className="leading-5">
                                                <div className="flex items-center gap-2">
                                                    <h1 className="font-semibold text-gray-800">{item.name}</h1>
                                                    <div className="flex items-center">
                                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8.00903 6.5C8.00903 4.294 9.80303 2.5 12.009 2.5C14.215 2.5 16.009 4.294 16.009 6.5C16.009 8.706 14.215 10.5 12.009 10.5C9.80303 10.5 8.00903 8.706 8.00903 6.5ZM14 12.5H10C5.94 12.5 4.5 15.473 4.5 18.019C4.5 20.296 5.71105 21.5 8.00305 21.5H15.9969C18.2889 21.5 19.5 20.296 19.5 18.019C19.5 15.473 18.06 12.5 14 12.5Z" fill="black" />
                                                        </svg>
                                                        <span className="font-semibold text-gray-800">{item.passenger_capacity}</span>
                                                    </div>
                                                </div>
                                                {(item?.dri_pic_time !== undefined && item?.dri_pic_drop) ? (
                                                    <span className="text-[15px] text-gray-600">{item?.dri_pic_time} {t("min away - Drop")} {item.dri_pic_drop}</span>
                                                ) : null}
                                            </div>
                                        </div>
                                        <span className="font-semibold">{currency + item.drop_price}</span>
                                    </div>
                                })}
                            </div>

                            <button onClick={handleContinueBooking} className="min-h-12 w-full mt-3 rounded-[8px] bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95">
                                {apiLoading === "Search"
                                    ? <BtnLoader CustomeStyle={"bg-white"} />
                                    : t("Continue Booking")}
                            </button>

                        </>)}

                    </div>

                    <div className="w-full h-[500px] lg:h-full relative rounded-[15px] overflow-hidden">
                        {mapLoad && <div className="w-full h-full absolute z-[555] bg-black/30">
                            <BtnLoader CustomeStyle={"bg-black"} />
                        </div>}
                        <Map pickupLocation={pickupLocation} dropLocation={dropLocation} stopList={stopList} step={step} HandleGetGoogleAddress={HandleGetGoogleAddress} categoryData={categoryData}
                        />
                    </div>

                </div>
            </div>

            <AnimatePresence initial={false}>
                {(showModel === "Pickup" || showModel === "Drop" || showModel === "Stop") && (
                    <div className="model items-center">

                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 30 }}
                            className="bg-white w-[450px] rounded-[15px] overflow-hidden"
                        >
                            <div className="px-5 py-2">
                                <div className="flex items-center justify-between">
                                    <h1 className='font-medium text-[20px]'>{t("Location search")}</h1>
                                    <button onClick={closeModal} className='hover:bg-gray-100 rounded-full p-2'>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="relative mt-3">
                                    <input
                                        ref={searchRef}
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder={t("Search location")}
                                        className="w-full border-2 pl-3 pr-10 py-2 rounded-lg outline-[--bg-color]"
                                    />
                                    {searchText && (
                                        <button
                                            onClick={() => setSearchText("")}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-650"
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </button>
                                    )}
                                </div>
                            </div>

                            {apiLoading === "Location" ? (
                                <div className="h-[300px]">
                                    <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
                                </div>
                            ) : (
                                <div className="max-h-[70vh] scroll-container py-2">
                                    {/* Allow Location Access Option */}
                                    <div onClick={handleGetCurrentLocation} className="px-[20px] py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-3 border-b border-gray-100">
                                        <div className="max-w-[40px] min-w-[40px] h-[40px] bg-black rounded-full flex items-center justify-center text-white">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="currentColor"/>
                                                <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2"/>
                                                <line x1="12" y1="2" x2="12" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <line x1="12" y1="20" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <line x1="2" y1="12" x2="4" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                <line x1="20" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                            </svg>
                                        </div>
                                        <div className="flex flex-col justify-center flex-grow min-w-0 text-start leading-5">
                                            <h1 className='font-semibold text-gray-900 text-sm leading-tight'>{t("Allow location access")}</h1>
                                            <p className='text-xs text-blue-500 mt-1'>{t("It provides your pickup address")}</p>
                                        </div>
                                    </div>

                                    <div onClick={() => { setShowModel(""); setStep(step + 1) }} className="px-[20px] py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-3">
                                        <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-black justify-center">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"><g fill="currentColor"><path d="M11.999 9.87a1.686 1.686 0 1 0 0-3.37c-.93 0-1.69.76-1.69 1.69 0 .93.76 1.68 1.69 1.68Z"></path><path fillRule="evenodd" clipRule="evenodd" d="M1 23V1h22v17H7l-5 5H1Zm11-8.1 3.36-3.36a4.74 4.74 0 0 0 0-6.71 4.753 4.753 0 0 0-6.72 0 4.75 4.75 0 0 0 0 6.71L12 14.9Z"></path></g></svg>
                                        </div>
                                        <div className="flex flex-col justify-center flex-grow min-w-0 text-start">
                                            <h1 className='font-semibold text-gray-900 text-sm leading-tight'>{t("Set location on map")}</h1>
                                        </div>
                                    </div>

                                    

                                    {searchText.length === 0 && (() => {
                                        const rawRecents = localStorage.getItem("recent_searches");
                                        const recents = rawRecents ? JSON.parse(rawRecents) : [];
                                        if (recents.length === 0) return null;
                                        return (
                                            <div>
                                                <h3 className="px-5 pt-3 pb-1 text-xs font-bold text-gray-400 uppercase tracking-wider text-start">{t("Recent Searches")}</h3>
                                                {recents.map((item, idx) => (
                                                    <div
                                                        key={`recent-${idx}`}
                                                        className="px-5 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-between group"
                                                    >
                                                        <div
                                                            onClick={() => {
                                                                const placeData = {
                                                                    name: item.title,
                                                                    formatted_address: item.subt,
                                                                    geometry: {
                                                                        location: {
                                                                            lat: item.lat,
                                                                            lng: item.lng
                                                                        }
                                                                    }
                                                                };
                                                                handleSelectLocation(placeData);
                                                            }}
                                                            className="flex items-center gap-3 flex-grow text-start min-w-0"
                                                        >
                                                            <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-gray-600 justify-center">
                                                                <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                                            </div>
                                                            <div className="flex flex-col justify-center flex-grow min-w-0">
                                                                <h1 className="font-semibold text-gray-700 text-sm leading-tight truncate">{item.title}</h1>
                                                                <p className="text-xs text-gray-500 line-clamp-1 mt-1 truncate">{item.subt}</p>
                                                            </div>
                                                        </div>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const rawRecents = localStorage.getItem("recent_searches");
                                                                let recentsList = rawRecents ? JSON.parse(rawRecents) : [];
                                                                recentsList = recentsList.filter(r => r.title !== item.title || r.subt !== item.subt);
                                                                localStorage.setItem("recent_searches", JSON.stringify(recentsList));
                                                                setRecentUpdateTrigger(prev => prev + 1);
                                                            }}
                                                            className="text-gray-400 hover:text-red-500 p-2 ml-2 flex-shrink-0"
                                                            title={t("Delete")}
                                                        >
                                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })()}

                                    {searchText.length > 0 && searchText.length < 3 && (
                                        <div className="px-5 py-6 text-center text-gray-500">
                                            <p className="text-sm">{t("Type at least 3 characters to search...")}</p>
                                        </div>
                                    )}

                                    {searchText.length >= 3 && searchData.length === 0 && (
                                        <div className="px-5 py-8 text-center text-gray-500 flex flex-col items-center">
                                            <svg className="w-12 h-12 text-gray-300 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                            </svg>
                                            <p className="font-semibold text-gray-700">{t("No results found")}</p>
                                            <p className="text-xs text-gray-400 mt-1">{t("Try checking spelling or choosing set on map.")}</p>
                                        </div>
                                    )}

                                    {searchData.map((item, index) => (
                                        <div
                                            key={index}
                                            className="px-5 py-3 hover:bg-gray-100 cursor-pointer flex items-center justify-between gap-3 border-b border-gray-50"
                                        >
                                            <div onClick={() => handleSelectLocation(item)} className="flex items-center gap-3 flex-grow text-start min-w-0">
                                                <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-black justify-center flex-shrink-0">
                                                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path d="M18.7 3.8C15 .1 9 .1 5.3 3.8c-3.7 3.7-3.7 9.8 0 13.5L12 24l6.7-6.8c3.7-3.6 3.7-9.7 0-13.4ZM12 12.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z" fill="currentColor"></path></svg>                                            
                                                </div>
                                                <div className="flex flex-col justify-center flex-grow min-w-0 text-start">
                                                    <h1 className="font-semibold text-gray-800 text-sm leading-tight">{item.name}</h1>
                                                    <p className="text-xs text-gray-500 line-clamp-1 mt-1">
                                                        {item.formatted_address}
                                                    </p>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    ))}

                                </div>
                            )}
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Price" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] relative mx-3"
                    >
                        <PriceModel data={modelData} setData={setModelData} setShowModel={setShowModel} setIsModel={setIsModel} selectPayment={selectPayment} selectCoupon={selectCoupon} setSelectCoupon={setSelectCoupon}
                            pickupLocation={pickupLocation} dropLocation={dropLocation} stopList={stopList} handleCancelRequest={handleCancelRequest} handleRequestTimeOut={handleRequestTimeOut} />
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {isModel === "Payment" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[500px] px-5 py-3 rounded-[20px] relative mx-3"
                    >
                        <Payment setIsModel={setIsModel} index={1} selectPayment={selectPayment} setSelectPayment={setSelectPayment} paymentList={paymentList} Amount={0} Data={null} />
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {isModel === "Coupon" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] relative mx-3"
                    >

                        <div className="flex items-center justify-between mb-2">
                            <h1 className='font-medium text-[20px]'>{t("Select Coupon")}</h1>
                            <button onClick={() => setIsModel("")} className='hover:bg-gray-100 rounded-full p-2'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                                </svg>
                            </button>
                        </div>

                        <div className="mt-2 max-h-[80vh] scroll-container">
                            {couponList.map((item, index) => {
                                const Isdisabled = item.min_amount > modelData?.bid_addjust_amount;
                                const IsApply = item.id === selectCoupon?.id;
                                return <div key={index} className="border p-5 rounded-[15px] mt-3 flex items-center justify-between agp-5">
                                    <div className="leading-[22px]">
                                        <h1 className="font-bold text-[19px]">{item.title}</h1>
                                        <span className="text-gray-600">{item.sub_title}</span>
                                        <p>{t("Coupon Code")} : <span className="font-semibold text-[--bg-color]">{item.code}</span></p>
                                        <p>{t("Coupon Amount")} : <span className="font-semibold">{currency + item.discount_amount}</span></p>
                                        <p>{t("Minimum Amount")} : <span className="font-semibold">{currency + item.min_amount}</span></p>
                                        <p>{t("Ex Date")} : <span className="font-semibold">{item.end_date.split(" ")[0]}</span></p>
                                        {!IsApply
                                            ? <button disabled={Isdisabled} onClick={() => { setSelectCoupon({ id: item.id, code: item.code, amt: item.discount_amount, min: item.min_amount }); setIsModel(""); }} className={`mt-2 border ${Isdisabled ? "border-gray-400 text-gray-400" : "border-[--bg-color] text-[--bg-color] hover:bg-[--bg-color] hover:text-white hover:scale-[1.02] active:scale-[0.98]"} px-6 py-[7px] rounded-[50px] font-semibold italic transition-all duration-200`}>
                                                {t("Apply Coupon")}
                                            </button>
                                            : <button onClick={() => { setSelectCoupon(null); setIsModel(""); }} className="mt-2 border border-red-600 text-red-600 italic font-semibold px-6 py-[7px] rounded-[50px] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200">
                                                {t("Remove Coupon")}
                                            </button>}
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 31 31" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M28.5187 11.0753L29.6351 12.1913C30.519 13.0593 30.9996 14.2373 30.9996 15.4773C31.0151 16.7173 30.5345 17.8969 29.6662 18.7788C29.6558 18.7902 29.6455 18.8002 29.6351 18.8102C29.63 18.8152 29.6248 18.8202 29.6196 18.8253L28.5187 19.9258C28.0846 20.3598 27.8365 20.9488 27.8365 21.5704V23.1653C27.8365 25.7383 25.7432 27.8324 23.1693 27.8324H21.5722C20.952 27.8324 20.3628 28.0788 19.9286 28.5128L18.8122 29.6288C17.8974 30.5449 16.7035 30.9928 15.5095 30.9928C14.3156 30.9928 13.1217 30.5449 12.2068 29.6459L11.0749 28.5128C10.6408 28.0788 10.0515 27.8324 9.43132 27.8324H7.83424C5.26031 27.8324 3.16705 25.7383 3.16705 23.1653V21.5704C3.16705 20.9488 2.91896 20.3598 2.4848 19.9103L1.3684 18.8098C-0.445762 16.9979 -0.461267 14.0358 1.35289 12.2084L2.4848 11.0753C2.91896 10.6413 3.16705 10.0523 3.16705 9.41684V7.83584C3.16705 5.26284 5.26031 3.17189 7.83424 3.17189H9.43132C10.0515 3.17189 10.6408 2.92234 11.0749 2.48834L12.1913 1.37234C14.0055 -0.455114 16.967 -0.455114 18.7967 1.35839L19.9286 2.48834C20.3628 2.92234 20.952 3.17189 21.5722 3.17189H23.1693C25.7432 3.17189 27.8365 5.26284 27.8365 7.83584V9.43389C27.8365 10.0523 28.0846 10.6413 28.5187 11.0753ZM11.511 20.8407C11.8831 20.8407 12.2242 20.7012 12.4723 20.4377L20.4422 12.4723C20.9694 11.9453 20.9694 11.0757 20.4422 10.5487C19.915 10.0233 19.0622 10.0233 18.535 10.5487L10.5651 18.5157C10.0379 19.0427 10.0379 19.9107 10.5651 20.4377C10.8132 20.7012 11.1543 20.8407 11.511 20.8407ZM18.1316 19.4764C18.1316 20.2359 18.7364 20.8404 19.4961 20.8404C20.2404 20.8404 20.8451 20.2359 20.8451 19.4764C20.8451 18.734 20.2404 18.1279 19.4961 18.1279C18.7364 18.1279 18.1316 18.734 18.1316 19.4764ZM11.5243 10.1605C12.2685 10.1605 12.8732 10.765 12.8732 11.509C12.8732 12.2701 12.2685 12.873 11.5243 12.873C10.78 12.873 10.1598 12.2701 10.1598 11.509C10.1598 10.765 10.78 10.1605 11.5243 10.1605Z" fill="#FFB733" />
                                    </svg>
                                </div>
                            })}
                        </div>

                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Busy" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] relative mx-3"
                    >

                        <div className="flex items-center justify-between">
                            <h1 className='font-medium text-[20px]'>{t("Captains are busy")}</h1>
                            <button onClick={() => setShowModel("")} className='hover:bg-gray-100 rounded-full p-2'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                                </svg>
                            </button>
                        </div>


                        <div className="py-5">
                            {allLocation.map((item, index) => (
                                <div key={index} className="flex items-start gap-3">
                                    <div className="flex flex-col items-center mt-[6px]">
                                        <div
                                            className={`${item.type === "Pickup"
                                                ? "location-icon-green"
                                                : "location-icon-red"
                                                }`}
                                        ></div>
                                        {index !== allLocation.length - 1 && (
                                            <div className="h-6 border-l-2 border-dashed border-gray-400 mt-2"></div>
                                        )}
                                    </div>
                                    <div className="leading-5">
                                        <h1 className="font-medium text-gray-800 line-clamp-1">
                                            {item.title}
                                        </h1>
                                        <p className="text-[15px] text-gray-600">{item.subt}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="flex items-center gap-3">
                            <button onClick={() => setShowModel("")} className="h-10 w-full rounded-[8px] bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform">{t("Try Again")}</button>
                            <button onClick={handleCancelRequest} className="h-10 w-full rounded-[8px] border border-[--bg-color] italic tracking-[1px] text-[--bg-color] font-bold">{t("Cancel")}</button>
                        </div>

                    </motion.div>
                </div>}
            </AnimatePresence>


            <AnimatePresence initial={false}>
                {showModel === "Login" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] px-5 py-3 rounded-[20px] space-y-4 mx-3"
                    >
                        <h1 className='font-medium text-[20px]'>{t("Log in to see ride options")}</h1>
                        <p className="text-[17px] leading-5">{t("Please take a moment to quickly log in or sign up so we can show you your ride options")}</p>
                        <button onClick={() => navigate("/auth/login-signup")} className="min-h-10 w-full rounded-[8px] bg-[--bg-color] italic hover:bg-[--bg-color-hover] tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95">
                            {t("Continue")}
                        </button>
                    </motion.div>
                </div>}
            </AnimatePresence>

            <PageLoader loading={loading} />

        </div>
    );
};

export default FindRide;
;